import PropTypes from 'prop-types';

import EmptyState from '@zenbusiness/zui/EmptyState';

import { useSearchParam } from '#client/hooks/useSearchParam';

function SearchEmptyState({ isSearchActive, hasResults, loading }) {
  const { clearAllSearchParams } = useSearchParam('');

  const hasNoSearchResults = isSearchActive && !hasResults && !loading;

  return (
    hasNoSearchResults && (
      <EmptyState
        description="Try another search"
        slotProps={{
          primaryAction: {
            label: 'Clear search',
            onClick: clearAllSearchParams
          }
        }}
        title="No results"
      />
    )
  );
}

SearchEmptyState.propTypes = {
  isSearchActive: PropTypes.bool.isRequired,
  hasResults: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired
};

export default SearchEmptyState;
